
function checkResponse(response, method) {
    if (response.status > 499) { // contempla errores 300, 400, y 500.
        return {
            "detail": "Error", // TO-DO: Verificar si ya existe clave detail de error, insertala aqui si luego se usará.
            "status": response.status
        }
    } else {
        if (method === "delete") return response
        else return response.json()
    }
};

export default function apiCall(method, url, options = null) {

    function shouldAddStatusHttp(response) { return response.url.includes('/token/') || response.url.includes('/2fa_validation/'); }

    if (options === null) {
        let body = null;
        return fetch(url, {
            method,
            body,
        }).then(response => {
            if (shouldAddStatusHttp(response)) {
                return (method === "delete")
                    ? { ...response, status_http: response.status }
                    : response.json().then(data => ({ ...data, status_http: response.status }));
            } else {
                return (method === "delete")
                    ? response
                    : response.json()
            }
        });
    } else {
        let body = options.body;
        let headers = options.headers;

        return fetch(url, {
            method,
            body,
            headers,
        }).then(response => {
            if (shouldAddStatusHttp(response)) {
                return (method === "delete")
                    ? { ...response, status_http: response.status }
                    : response.json().then(data => ({ ...data, status_http: response.status }))
            } else {
                return response.text().then(text => {
                    let data;
                    try {
                        data = JSON.parse(text);
                    } catch (e) {
                        data = { detail: text || "Non-JSON response", status_http: response.status };
                    }
                    if (!response.ok) {
                        console.error("API CALL REJECTED:", {
                            status: response.status,
                            statusText: response.statusText,
                            body: data
                        });
                    }
                    return (method === "delete") ? response : data;
                });
            }
        });
    }
}